<div class="card card--no-padding">
  <div class="kpi-table">
    <header class="kpi-table__header">{{ title() }}</header>
    <div class="kpi-table__row">
      <div class="kpi-table__col"></div>
      @for (item of kpiItems(); track $index) {
        <div class="kpi-table__col" [matTooltip]="item.name" [matTooltipPosition]="'above'">
          <h4 class="truncate">KPI {{ $index + 1 }}</h4>
          <div class="truncate kpi-table__subtitle">{{ item.name }}</div>
        </div>
      }
    </div>
    @for (row of kpiRows(); track $index) {
      <div class="kpi-table__row">
        <div class="kpi-table__col">
          <div class="truncate">{{ "kpi.days" + row.days | translate }}</div>
        </div>
        @for (col of row.values; track $index) {
          <div class="kpi-table__col kpi-table__col--{{ getStatus(col.value, col.kpi.danger, col.kpi.warning) }}">
            <!--  "| number: '1.1-1'" is added to ensure always 1 decimal is shown -->
            {{ col.value !== undefined ? (col.value | number: "1.1-1") : "?" }}
            @if (col.kpi.percentage && col.value !== undefined) {
              <span>%</span>
            }
          </div>
        }
      </div>
    }
  </div>
</div>
